import { useEffect, useState } from "react";
import { Phone, Mail } from "lucide-react";
import api from "../../lib/api";
import SEO from "../../components/site/SEO";
import { dateHeureFr } from "./ui";

const COULEURS_TYPE = {
  Pneus: "bg-brand-red text-white",
  "Parallélisme": "bg-brand-redhover text-white",
  Climatisation: "bg-brand-navy text-white",
  Mécanique: "bg-brand-dark text-white",
  Autre: "bg-gray-400 text-white",
};

export default function AdminDemandes() {
  const [demandes, setDemandes] = useState(null);

  const charger = () => api.get("/admin/demandes").then((r) => setDemandes(r.data)).catch(() => setDemandes([]));
  useEffect(() => { charger(); }, []);

  const basculer = async (d) => {
    await api.patch(`/admin/demandes/${d.id}`, { traitee: !d.traitee });
    charger();
  };

  return (
    <div data-testid="admin-demandes" className="max-w-4xl">
      <SEO title="Demandes reçues — Espace gérant | Promo Pneus" description="Demandes de devis reçues par le site." />
      <h1 className="font-heading font-bold uppercase text-4xl text-brand-dark tracking-tight mb-2">Demandes reçues</h1>
      <p className="text-brand-body text-lg mb-8">
        Les plus récentes en haut. Cochez « Traitée » une fois le client rappelé.
      </p>

      {demandes === null && <p className="text-brand-body text-lg">Chargement des demandes…</p>}
      {demandes !== null && demandes.length === 0 && (
        <p className="bg-white p-8 text-brand-body text-lg shadow-sm" data-testid="demandes-vide">
          Aucune demande pour le moment. Dès qu'un visiteur envoie le formulaire, sa demande apparaît ici.
        </p>
      )}

      <div className="space-y-4">
        {(demandes || []).map((d) => (
          <article key={d.id} data-testid={`demande-carte-${d.id}`}
            className={`bg-white p-5 shadow-sm border-l-4 ${d.traitee ? "border-gray-300 opacity-70" : "border-brand-red"}`}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div>
                <p className="font-heading font-semibold uppercase text-2xl text-brand-dark">{d.nom}</p>
                <p className="text-sm text-brand-body">{dateHeureFr(d.created_at)}</p>
              </div>
              <span className={`font-heading font-semibold uppercase text-sm tracking-wider px-3 py-1.5 ${COULEURS_TYPE[d.type_demande] || COULEURS_TYPE.Autre}`}>
                {d.type_demande}
              </span>
            </div>
            <div className="mt-3 flex flex-wrap gap-3">
              <a href={`tel:${d.telephone.replace(/\s/g, "")}`} data-testid={`demande-tel-${d.id}`}
                className="inline-flex items-center gap-2 bg-brand-red hover:bg-brand-redhover text-white font-heading font-semibold uppercase tracking-wider px-5 py-3 text-lg transition-colors">
                <Phone size={20} aria-hidden="true" /> {d.telephone}
              </a>
              {d.email && (
                <a href={`mailto:${d.email}`} data-testid={`demande-email-${d.id}`}
                  className="inline-flex items-center gap-2 bg-brand-light hover:bg-gray-200 text-brand-dark font-heading font-semibold uppercase tracking-wider px-5 py-3 text-lg transition-colors break-all">
                  <Mail size={20} aria-hidden="true" /> {d.email}
                </a>
              )}
            </div>
            {d.message && (
              <p className="mt-4 bg-brand-light px-4 py-3 text-brand-dark font-body leading-relaxed whitespace-pre-wrap">
                {d.message}
              </p>
            )}
            <label className="mt-4 flex items-center gap-3 cursor-pointer w-max">
              <input type="checkbox" data-testid={`demande-traitee-${d.id}`} checked={d.traitee}
                onChange={() => basculer(d)} className="w-6 h-6 accent-[#E8492F]" />
              <span className="font-heading font-semibold uppercase tracking-wider text-lg text-brand-dark">Traitée</span>
            </label>
          </article>
        ))}
      </div>
    </div>
  );
}
